import { computed, watch, nextTick } from 'vue';import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.some.js";
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import { getSessionItem } from '@/utils/sessionstorage';
const {
  mapGetters,
  mapState,
  mapMutations
} = createNamespacedHelpers('moduleCommon');
export default {
  name: 'SideBar',
  data() {
    return {
      activedId: null,
      openedMenu: [],
      // 当前打开的菜单信息
      timer: null,
      worker: null,
      showHous: '',
      showDay: '',
      showWeek: '',
      weekMap: {
        0: '日',
        1: '一',
        2: '二',
        3: '三',
        4: '四',
        5: '五',
        6: '六'
      }
    };
  },
  computed: {
    ...mapGetters(['getSideMenuArr', 'getUserInfo', 'getSideStatus']),
    ...mapState(['sideOpen', 'sideActive', 'token', 'sideMenuOther'])
  },
  watch: {
    sideOpen: {
      handler(newVal) {
        if (Array.isArray(newVal)) {
          this.openedMenu = [...newVal];
        }
      },
      immediate: true
    },
    sideActive: {
      handler(newVal) {
        if (newVal) {
          this.activedId = newVal;
        }
      },
      immediate: true
    }
  },
  mounted() {
    if (this.token) {
      this.filterDate();
      this.getTimeData();
    }
  },
  methods: {
    ...mapMutations(['SIDE_ACTIVE', 'IS_ROUTER_ALIVE']),
    handleSelect(item) {
      let key = item.name;
      if (item.children) {
        key = item.children[0].name;
      }
      // 判断是否当前页
      if (this.$route.name === key) {
        this.IS_ROUTER_ALIVE(false);
        this.$nextTick(() => {
          this.IS_ROUTER_ALIVE(true);
        });
      } else {
        this.$router.push({
          name: key
        });
        this.SIDE_ACTIVE(key);
      }
    },
    // 调动时间
    getTimeData() {
      this.timer = setInterval(() => {
        this.filterDate();
      }, 1000);
    },
    // 对时间的处理信息
    setTime() {
      const start = new Date().getTime();
      let count = 0;
      const inits = 1000;
      let offset = 0; // 误差时间
      let nextTime = inits - offset;
      const doFunc = () => {
        count++;
        offset = new Date().getTime() - (start + count * inits);
        nextTime = inits - offset;
        if (nextTime < 0) {
          nextTime = 0;
        }
        this.filterDate();
        this.timer = setTimeout(doFunc, nextTime);
      };
      this.timer = setTimeout(doFunc, nextTime);
    },
    // 时间过滤展示
    filterDate() {
      const date = getSessionItem('zl-login-date') || this.getUserInfo.lastLogin;
      const filterDate = date + (new Date().getTime() - getSessionItem('zl-login-now-date'));
      const week = moment(filterDate).format('d');
      this.showWeek = this.weekMap[week];
      this.showDay = moment(filterDate).format('YYYY-MM-DD');
      this.showHous = moment(filterDate).format('HH:mm:ss');
    },
    // 是否选中状态
    modifyActived(item) {
      let res = false;
      if (Array.isArray(item?.children)) {
        item.children.some(data => {
          res = data.name === this.activedId;
          return res;
        });
      } else {
        if (item.name === this.activedId) {
          res = true;
        }
      }
      return res;
    },
    // 子级菜单选中状态
    childActived(item) {
      let res = false;
      if (Array.isArray(item?.children)) {
        item.children.some(data => {
          res = data.name === this.activedId;
          if (!res && Array.isArray(data.children)) {
            res = data.children.some(childData => {
              return childData.name === this.activedId;
            });
          }
          return res;
        });
      } else {
        if (item.name === this.activedId) {
          res = true;
        }
      }
      return res;
    },
    // 展示下级菜单
    showChildMenu(menu) {
      return menu.children && menu.children.some(list => list.meta.menuShow);
    },
    // 最大数
    maxNum(num) {
      return parseInt(num) > 99 ? '99+' : num;
    }
  },
  beforeUnmount() {
    clearTimeout(this.timer);
  }
};